"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMsgMigrateContract = exports.isMsgExecuteContract = exports.isMsgClearAdmin = exports.isMsgUpdateAdmin = exports.isMsgInstantiateContract = exports.isMsgStoreCode = void 0;
function isMsgStoreCode(msg) {
    return msg.type === "wasm/MsgStoreCode";
}
exports.isMsgStoreCode = isMsgStoreCode;
function isMsgInstantiateContract(msg) {
    return msg.type === "wasm/MsgInstantiateContract";
}
exports.isMsgInstantiateContract = isMsgInstantiateContract;
function isMsgUpdateAdmin(msg) {
    return msg.type === "wasm/MsgUpdateAdmin";
}
exports.isMsgUpdateAdmin = isMsgUpdateAdmin;
function isMsgClearAdmin(msg) {
    return msg.type === "wasm/MsgClearAdmin";
}
exports.isMsgClearAdmin = isMsgClearAdmin;
function isMsgExecuteContract(msg) {
    return msg.type === "wasm/MsgExecuteContract";
}
exports.isMsgExecuteContract = isMsgExecuteContract;
function isMsgMigrateContract(msg) {
    return msg.type === "wasm/MsgMigrateContract";
}
exports.isMsgMigrateContract = isMsgMigrateContract;
//# sourceMappingURL=msgs.js.map